import { ButtonProps } from '@mui/material/Button';
import './style.css';

interface IButtonProps extends ButtonProps {
    label: string;
    onClick: () => void;
    isReturnButton?: boolean;
    props?: ButtonProps;
}

export default function ButtonSecondaryComponent({ label, onClick, isReturnButton, props }: IButtonProps) {
  return (
    <div className="button-container-secondary">
      {!isReturnButton && 
        <button 
          className="button-secondary" 
          onClick={() => onClick()}
          {...props}
        > {label}</button>}

      {isReturnButton && 
        <button 
          className="button button-return" 
          onClick={() => onClick()}
          {...props}
        > {label}</button>}
    </div>
  );
}